<template>
    <div style="touch-action: manipulation">
        <form-group>
            <form-label>Adults (13 or above)</form-label>
            <input-group class="mt-1">
                <ui-button :outline="true" @click="decreaseAdults" :disabled="((numberAdults == null) || (numberAdults <= 1)) ? true : false">
                    <i class="fas fa-minus"></i>
                </ui-button>
                <form-number name="number-of-adults" v-model="numberAdults" class="text-center" @input="emitUpdate" />
                <ui-button :outline="true" @click="increaseAdults">
                    <i class="fas fa-plus"></i>
                </ui-button>
            </input-group>
        </form-group>

        <form-group>
            <form-label>Children (12 and under)</form-label>
            <input-group class="mt-1">
                <ui-button :outline="true" @click="decreaseChildren" :disabled="((numberChildren == null) || (numberChildren <= 0)) ? true : false">
                    <i class="fas fa-minus"></i>
                </ui-button>
                <form-number name="number-of-children" v-model="numberChildren" class="text-center" @input="emitUpdate" />
                <ui-button :outline="true" @click="increaseChildren">
                    <i class="fas fa-plus"></i>
                </ui-button>
            </input-group>
        </form-group>

        <form-group>
            <form-checkbox v-model="pets" :switch="true" @input="emitUpdate">
                I am traveling with pets
            </form-checkbox>
            <form-text>
                If checked, only properties that allow pets will be shown
            </form-text>
        </form-group>

        <div class="text-end mt-3" :class="uiStore.isMobile ? 'd-flex align-items-center' : null">
            
            <ui-button v-if="uiStore.isMobile" size="sm" color="light" @click="$emit('close')" class="me-auto">
                Close
            </ui-button>

            <ui-button size="sm" color="light" @click="clear" class="me-2">
                Clear
            </ui-button>
            <ui-button size="sm" @click="apply">
                Apply
            </ui-button>
        </div>
    </div>
    
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                numberAdults: null,
                numberChildren: null,
                pets: null,
            };
        },

        emits: ['close', 'clear', 'update:modelValue'],

        props: {
            modelValue: {
                type: Object,
                default: null,
            },
        },

        created() {
            this.setSearchData();

            this.$watch(
                () => this.modelValue,
                this.setSearchData,
                { deep: true }
            );
        },

        methods: {

            setSearchData() {
                let adults = null;
                let children = null;
                let pets = null;

                if (this.modelValue) {
                    adults = this.modelValue.adults;
                    children = this.modelValue.children;
                    if (this.modelValue.pets) {
                        pets = true;
                    }
                }

                this.numberAdults = adults;
                this.numberChildren = children;
                this.pets = pets;
            },

            clear() {
                this.numberAdults = null;
                this.numberChildren = null;
                this.pets = false;
                this.$emit('clear');
                this.emitUpdate();
            },

            apply() {
                this.emitUpdate();
                this.$emit('close');
            },

            decreaseAdults() {
                if ((this.numberAdults != null) && (this.numberAdults > 1)) {
                    this.numberAdults--;
                    if (!this.uiStore.isMobile) {
                        this.emitUpdate();
                    }
                }
            },

            increaseAdults() {
                if (this.numberAdults == null) {
                    this.numberAdults = 1;
                }
                else {
                    this.numberAdults++;
                }
                if (!this.uiStore.isMobile) {
                    this.emitUpdate();
                }
            },

            decreaseChildren() {
                if ((this.numberChildren != null) && (this.numberChildren > 0)) {
                    this.numberChildren--;
                    if (!this.uiStore.isMobile) {
                        this.emitUpdate();
                    }
                }
            },

            increaseChildren() {
                if (this.numberChildren == null) {
                    this.numberChildren = 1;
                }
                else {
                    this.numberChildren++;
                }
                if (!this.uiStore.isMobile) {
                    this.emitUpdate();
                }
            },

            emitUpdate() {
                
                let data = {
                    adults: this.numberAdults,
                    children: this.numberChildren,
                    pets: this.pets,
                };

                this.$emit('update:modelValue', data);
            },
        }

    };

</script>
